var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"mt-4 mb-8"},[_c('p',{staticClass:"py-3 rounded-sm bg-green-400 text-white text-sm"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }